import MaterialBox from "../../../../__snowpack__/pkg/@mui/material/Box.js";
import styled from "styled-components";
export const FormContainer = styled(MaterialBox).withConfig({
  displayName: "form-drawerstyles__FormContainer",
  componentId: "sc-f1a1ps-0"
})(["", " > form > fieldset > div{", "}"], {
  display: "flex",
  flex: "1 1 0%"
}, {
  flex: "1 1 0%"
});
export const InputContainer = styled(MaterialBox).withConfig({
  displayName: "form-drawerstyles__InputContainer",
  componentId: "sc-f1a1ps-1"
})(["", " > .MuiFormControl-root{", "}"], {
  display: "flex",
  flex: "1 1 0%",
  flexDirection: "column"
}, {
  marginBottom: "1rem"
});
export const ActionContainer = styled(MaterialBox).withConfig({
  displayName: "form-drawerstyles__ActionContainer",
  componentId: "sc-f1a1ps-2"
})(["", " & >:first-child{", "}"], {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: "1rem"
}, {
  marginRight: "1rem"
});
